import React from 'react'
import { SuccessPage } from 'components'

export default function Success() {
  return <SuccessPage />
}
